import { render, staticRenderFns } from "./PersonTemplate.vue?vue&type=template&id=505ac9c1&"
import script from "./PersonTemplate.vue?vue&type=script&lang=js&"
export * from "./PersonTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports